import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeFilters } from 'actions/search';
import { Link } from 'react-router-dom';
import { getHighlightedText } from '../utils';

import s from '../style';

@connect(null, { changeFilters })
export default class SubRegions extends Component {
  onItemClick = (ids) => {
    this.props.changeFilters({ subregion: ids });
    this.props.closeModal();
  }

  render() {
    const {
      name,
      items,
      isShown,
      highlight
    } = this.props;

    if (isShown && items.length) {
      return (
        <div className={s.resultSection}>
          <div className={s.resultSectionTitle}>{name} ({items.length})</div>
          {items.map(item => {
            const ids = [item.id];
            return (
              <Link
                to={`/?subregion=${ids.join(',')}`}
                key={item.id}
                className={s.resultItemRegion}
              >
                <div onClick={() => this.onItemClick(ids)} className={s.resultItemTitleRegion}>
                  {getHighlightedText(item.name, highlight)}
                </div>
              </Link>
            );
          })}
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/SubRegions/SubRegions.js